module.exports = __webpack_public_path__ + "img/yanxue_left-road.97e76750.png";